import axios from '../../axios'

/**
 * 1.5.1 获取体测分组信息
 * @returns {Promise | Promise<unknown>}
 */
export const groupList = () => {
  return axios({
    url: '/clubExamines/examinGroup/groupList',
    method: 'GET'
  })
}

/**
 * 1.5.2 添加组别
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const addExaminGroup = data => {
  return axios({
    url: '/clubExamines/examinGroup/addExaminGroup',
    method: 'POST',
    data
  })
}

/**
 * 1.5.3  修改组别
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const updateExaminGroup = data => {
  return axios({
    url: '/clubExamines/examinGroup/updateExaminGroup',
    method: 'PUT',
    data
  })
}

/**
 * 1.5.4  删除组别
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const delExaminGroup = id => {
  return axios({
    url: '/clubExamines/examinGroup/delExaminGroup/' + id,
    method: 'DELETE'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/examines/examinGroup.js